export interface TemplateSection {
    label?: string;
    label_id?: string; // ID pour les traductions
    tooltip_id?: string; // ID pour les tooltips de traduction
    section_id?: string;
    type?: Section.TypeEnum;
    visible?: boolean;
    visibility_editable?:boolean;
    config?: any;
    sub_sections?: any;
  }
  export namespace Section {
    export type TypeEnum =
      | "CUSTOM"
      | "PRODUCTS"
      | "CATEGORIES"
      | "MULTIPLE"
      | "PRODUCT"
      | "REVIEWS";
    export const TypeEnum = {
      CUSTOM: "CUSTOM" as TypeEnum,
      PRODUCTS: "PRODUCTS" as TypeEnum,
      CATEGORIES: "CATEGORIES" as TypeEnum,
      MULTIPLE: "MULTIPLE" as TypeEnum,
      PRODUCT: "PRODUCT" as TypeEnum,
      REVIEWS: "REVIEWS" as TypeEnum,
    };
  }
  